import LaneDetailView from './LaneDetailView';
import LaneListView from './LaneListView';

const views = {
  LaneDetailView,
  LaneListView,
};
export default views;
